module.exports = __webpack_public_path__ + "a.no2.a4157138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/a.no2.jpg
// module id = UqF/
// module chunks = 0